import React, { useState } from "react";
import "./NetworkSection.css";

const NETWORK_DATA = {
  Maharashtra: [
    "Pune (Head Office)",
    "Mumbai",
    "Nagpur",
    "Nashik",
    "Aurangabad",
    "Kolhapur",
    "Solapur",
  ],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar"],
  "Delhi NCR": ["Delhi / New Delhi", "Gurugram", "Noida", "Faridabad", "Ghaziabad"],
  Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Trichy", "Salem"],
  "Telangana & Andhra Pradesh": [
    "Hyderabad",
    "Vijayawada",
    "Visakhapatnam",
    "Tirupati",
  ],
  Rajasthan: ["Jaipur", "Udaipur", "Jodhpur", "Kota"],
  "Madhya Pradesh": ["Indore", "Bhopal", "Gwalior"],
  "Punjab & Haryana": ["Chandigarh", "Ludhiana", "Amritsar"],
  "Eastern & North-East India": [
    "Kolkata",
    "Patna",
    "Ranchi",
    "Bhubaneswar",
    "Guwahati",
  ],
  Kerala: ["Kochi", "Trivandrum", "Kozhikode"],
  UttarPradesh: ["Lucknow"],
};

const NetworkSection = () => {
  const [activeState, setActiveState] = useState("Maharashtra");

  return (
    <section className="network-root">
      <div className="network-header-wrap">
        <h2 className="network-title">
          Pune Corporate Cars India Pvt. Ltd.
        </h2>
        <p className="network-subtitle">
          Pan-India Network – 10 Metros & 40+ Cities
        </p>
      </div>

      <div className="network-layout">
        {/* STATES LIST */}
        <aside className="state-list-panel">
          <h3 className="state-list-title">States</h3>

          <ul className="state-list">
            {Object.keys(NETWORK_DATA).map((state) => (
              <li
                key={state}
                className={`state-list-item ${
                  activeState === state ? "state-active" : ""
                }`}
                onClick={() => setActiveState(state)}
              >
                <span className="state-name">{state}</span>
                <span className="state-city-count">
                  {NETWORK_DATA[state].length}
                </span>
              </li>
            ))}
          </ul>
        </aside>

        {/* CITIES LIST */}
        <main className="city-display-panel">
          <h3 className="city-panel-title">
            Cities in {activeState}
          </h3>

          <div className="city-grid-wrapper">
            {NETWORK_DATA[activeState].map((city) => (
              <div key={city} className="city-grid-card">
                <span className="city-name-text">{city}</span>
              </div>
            ))}
          </div>
        </main>
      </div>
    </section>
  );
};

export default NetworkSection;
